(function () {
    'use strict';

    class FullScreen {
        static async goFullScreen() {
            try {
                const el = document.documentElement;

                if (el.requestFullscreen) {
                    await el.requestFullscreen();
                } else if (el.mozRequestFullScreen) {
                    await el.mozRequestFullScreen();
                } else if (el.webkitRequestFullscreen) {
                    await el.webkitRequestFullscreen();
                } else {
                    return;
                }

                if (screen.orientation?.lock) {
                    await screen.orientation.lock('landscape');
                }
            } catch (error) {
            }
        }

        static async cancelFullScreen() {
            try {
                if (document.exitFullscreen) {
                    await document.exitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    await document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    await document.webkitExitFullscreen();
                }
            } catch (error) {
            }
        }
    }

    module.exports = FullScreen;
})();
